import { ShopifyFulfillmentHoldReason } from "@redotech/redo-model/fulfillments/shopify-fulfillment-schemas";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const placeHolds = {
  name: "placeHolds" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    holdUntil: z.coerce.date().nullish(),
    reason: z.string().nullish(),
    reasonOption: createEnum(ShopifyFulfillmentHoldReason),
  }),
  output: z.object({ failedGroupIds: z.array(z.string()) }),
};
